import { TabNavigation, type Tab } from '@xtnd/web/shared/components';
import { MatterArTabId } from '../../types';

type Props = {
  activeTab: MatterArTabId;
  onTabChange: (tabId: MatterArTabId) => void;
};

export default function MatterArTab({ activeTab = 'invoices', onTabChange}: Props) {

  const innerTabs: Tab[] = [
    {
      id: 'invoices',
      label: 'Outstanding Invoices',
    },
    {
      id: 'attempts',
      label: 'Collection Attempts',
    },
  ];

  return (
    <TabNavigation
      fullWidthNavigation
      tabs={innerTabs}
      activeTab={activeTab}
      onTabChange={(tabId: string) => onTabChange(tabId as MatterArTabId)}
    />
  );
}
